import { Component, ElementRef, EventEmitter, HostListener, inject, Input, model, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { IconSquarePenComponent } from '../icon-square-pen/icon-square-pen.component';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [IconSquarePenComponent, LoadingSpinnerComponent, CommonModule],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css'
})
export class DropdownComponent {
  private elementRef = inject(ElementRef);

  isDropdownOpen = false;

  @Input() align: 'left' | 'right' = 'right';
  optionItems = model<any[]>([]);
  @Input() data: any | undefined;
  @Output() dataSelected = new EventEmitter<any>();

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  isItemDisabled(item: any): boolean {
    if (!item) {
      return false;
    }
    if (typeof item.disabled === 'function') {
      return !!item.disabled();
    }
    return !!item.disabled;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.isDropdownOpen && !this.elementRef.nativeElement.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  getDataSelected(callback?: Function) {
    if (this.data !== undefined) {
      this.dataSelected.emit(this.data);
    }
    if (callback && typeof callback === 'function') {
      callback();
    }
    this.isDropdownOpen = false;
  }

}
